<template>
    <div class="noData" >
        <img src="@/assets/images/lawJournal/noData.jpg" alt="">
        <p>暂无数据</p>
    </div>
 </template>
 <script>
 export default {
 }
 </script>
 <style lang="scss" scoped>
.noData{
  text-align: center;
  color: #585a5a;
  p{
    margin-top: -15px;
  }
}
 </style>